import React, { useState, useEffect } from 'react';
import '../styles/WaitlistModal.css';

const WaitlistModal = ({ isOpen, onClose, onSubmit }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null
  const [isClosing, setIsClosing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Call the onSubmit callback with the email
      const success = await onSubmit(email);
      
      if (success) {
        setSubmitStatus('success');
        setEmail('');
        // Auto-close after 2 seconds on success
        setTimeout(() => {
          setIsClosing(true);
          setTimeout(() => {
            setSubmitStatus(null);
            setIsClosing(false);
            onClose();
          }, 200); // Match animation duration
        }, 4000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setEmail('');
      setSubmitStatus(null);
      setIsClosing(false);
      onClose();
    }, 200); // Match animation duration
  };

  if (!isOpen && !isClosing) return null;

  return (
    <div className={`waitlist-modal-overlay ${isClosing ? 'closing' : ''}`} onClick={handleClose}>
      <div className={`waitlist-modal ${isClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
        <button className="waitlist-modal-close" onClick={handleClose} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="#040404" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <div className="waitlist-modal-content">
          {submitStatus !== 'success' && (
            <>
              <h2 className="waitlist-modal-title">Get early access</h2>
              <p className="waitlist-modal-subtitle">
                Fiktion will be rolled out soon in a closed beta. <br></br>You'll be notified when it's ready.
              </p>
            </>
          )}
          
          {submitStatus === 'success' ? (
            <div className="waitlist-modal-success">
              <h2 className="waitlist-modal-title">You've got mail</h2>
              <p>Thank you so much! You're now on the waitlist and will be notified when it's ready.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="waitlist-modal-form">
              <div className="waitlist-modal-input-wrapper">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="waitlist-modal-input"
                  required
                  disabled={isSubmitting}
                />
                {submitStatus === 'error' && (
                  <p className="waitlist-modal-error">Please enter a valid email address.</p>
                )}
              </div>
              <button 
                type="submit" 
                className="waitlist-modal-submit btn btn-large btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Joining...' : 'Join Waitlist'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default WaitlistModal;

